import config from "../config/default";
import { routesConfig } from "../config/routes";

interface MicrosoftLoginParams {
  url?: string | null;
  rules?: string | null;
}

/**
 * Builds the page the mw-auth broker redirects back to after Microsoft login.
 * `url` and `rules` are round-tripped so the callback knows where to send the user.
 */
export function buildReturnTo(params: MicrosoftLoginParams): string {
  const search = new URLSearchParams();
  if (params.url) search.set("url", params.url);
  if (params.rules) search.set("rules", params.rules);
  const query = search.toString();
  return `${window.location.origin}${routesConfig.MICROSOFT_CALLBACK}${query ? `?${query}` : ""}`;
}

/**
 * Sends the browser to mw-auth to start the corporate ("Login Corporativo") flow.
 */
export function startMicrosoftLogin(params: MicrosoftLoginParams): void {
  const returnTo = buildReturnTo(params);
  window.location.href = `${config.api.url}/auth/microsoft/authorize?return_to=${encodeURIComponent(returnTo)}`;
}
